<template>
  <div class="emb-signIn-wrap section-gap">
    <div class="container py-0">
      <v-layout row wrap align-center justify-center>
        <v-flex sm12 md12 lg8 xl7>
          <v-layout row mx-sm-0 mx-3 wrap align-center justify-center>
            <v-flex sm6 md7 lg6 xl6 hidden-sm-and-down>
              <div class="form-img sign-in-image" :style="'background-image: url('+ signSection.Image_800x1202_px +');'"></div>
            </v-flex>
            <v-flex sm10 md5 lg5 xl6>
              <div class="emb-card sign-in-form form-margin d-block white pa-6">
                <h4>{{signSection.Sign_In_Title}}</h4>

                <v-form>
                  <v-text-field
                    v-model="email"
                    type="email"
                    :placeholder="signSection.Email_Placeholder"
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    type="password"
                    :placeholder="signSection.Password_Placeholder"
                  ></v-text-field>
                  <div class="layout align-center justify-space-between">
                    <v-checkbox v-model="checkbox" :label="signSection.Remember_Me_Label"></v-checkbox>
                    <router-link
                      :to="signSection.Forgot_Password_Path"
                      class="text-lg-right"
                    >{{signSection.Forgot_Password_Label}}</router-link>
                  </div>
                  <v-btn
                    class="accent mb-3 ma-0"
                    large
                    @click.stop.prevent="userDetail"
                  >{{signSection.Sign_In_Button_Label}}</v-btn>
                  <p>
                    {{signSection.Click_Here_Label}}
                    <router-link
                      :to="signSection.Sign_Up_Path"
                      class="accent--text"
                    >{{signSection.Create_account}}</router-link>
                  </p>
                </v-form>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import gettingRestClientObject from "../../../services/utils/cms-helper";
import 'vue-toast-notification/dist/theme-default.css';
import VueToast from "vue-toast-notification";
Vue.use(VueToast, {
  position: "top-right"
});
export default {
  data() {
    return {
      email: "",
      password: "",
      checkbox: false,
      cmsRequestFunctions: "",
      signSection: ""
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
  },
  methods: {
    userDetail() {
      if ( !this.password ) {
        Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M009'));
    
        return false;
      }
      var emailPat = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
      var matchArray = this.email.match(emailPat);
      if (!this.email) {
        Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M007'));

        return false;
      } 
      if (matchArray == null) {
       Vue.$toast.warning(this.cmsRequestFunctions.getValidationMsgByCode('M010'));
    
        return false;
      }
      else{
      Vue.$toast.success(this.cmsRequestFunctions.getValidationMsgByCode('M014'));
      window.location="/session/thank-you";
      }
    },
    getPageData: function() {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "06 Login/06 Login/06 Login.ftl",
        lang: language,

        successCallback: function(response) {
          var res = response.data;

          if (res.area_List) {
            var Signin = self.cmsRequestFunctions.pluck(
              "Sign_In_Section",
              res.area_List
            );
            self.signSection = self.cmsRequestFunctions.getAllMapData(
              Signin[0].component
            );
          }
        },
        errorCallback: function(error) {
          console.log(error);
        }
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    }
  }
};
</script>	
